import { fillXmlFormDemoFromUpload } from '@/pages/api/scribeAPIV2';
import {
  type FillXmlFormDemoFromUploadRequest,
  type FillXmlFormDemoResponse,
} from '@/types';
import { DEMO_FILL_XML_FORM_FROM_UPLOAD_MUTATION_KEY } from '@heidi/templates/contracts';
import { useMutation } from '@tanstack/react-query';

export function useMutateFillXmlFormDemoFromUpload() {
  return useMutation<FillXmlFormDemoResponse, Error, FillXmlFormDemoFromUploadRequest>({
    mutationKey: DEMO_FILL_XML_FORM_FROM_UPLOAD_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillXmlFormDemoFromUpload(request);
      return data;
    },
  });
}
